import React from "react"

import HeaderPopup from "./HeaderPopup"
import { container } from "@components/wrapper"
import clsx from "clsx"
import { LinkHead } from "../HeaderComponent"

export function AboutPopover({ transparent }: { transparent?: boolean }) {
  const PopoverComponent = () => {
    return (
      <div className={clsx(container, "text-black")}>
        <div className="mt-5 text-2xl font-bold font-urbanist">About</div>
        <div className="flex gap-12 mt-5 ">
          <div className="w-2/5">
            Karena kesuksesan ialah hak setiap anak bangsa, kami berambisi untuk memberikan akses
            pendidikan yang berkualitas pada generasi muda Indonesia.
          </div>
          <div className="grid grid-cols-2 gap-4 w-1/2">
            <LinkHead link="/tentang-kami">Tentang Kami</LinkHead>
            <LinkHead link="/alumni">Alumni</LinkHead>
          </div>
        </div>
      </div>
    )
  }

  return (
    <HeaderPopup
      menuKey="about"
      panel={<PopoverComponent />}
      buttonLabel="About"
      transparent={transparent}
    />
  )
}
